import { useAuthBearerFetch } from "matsuri-hooks"
import { PhotoTourImage } from "@/model/photoTourImage"
import { PhotoTourMovie } from "@/model/movie"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"

export const useTourMedia = (token: string, cleaningId?: string) => {
    return useAuthBearerFetch<TourMedia>(
        token,
        cleaningId
            ? m2mCleaning_cleanerV3.cleanerGetCleaningPhotoTourMedia({
                  cleaningId
              })
            : null,
        {}
    )
}

export interface TourMedia {
    images: PhotoTourImage[]
    movies: PhotoTourMovie[]
}
